import {Button, Col, DatePicker, Form, Input, InputNumber, message, Row} from "antd";
import dayjs from "dayjs";
import {DATE_FORMAT, DEFAULT_GUTTER} from "../../constants";
import CdnImageUpload from "../CdnImageUpload";
import React, {useEffect} from "react";
import api from "../../api";


export default function OfferForm(
    {
        onOffersChanged,
        offer = null,
        plantingId = null,
        initialValues = {
            unit: "stuk",
            start_at: dayjs(),
            end_at: dayjs().add(1, 'month'),
        }
    }) {

    const [form] = Form.useForm();

    const image = offer && offer.image ? offer.image : (initialValues.image || null);

    function onSubmit() {
        if (offer && offer.id) {
            api.updateOffer(offer.id, form.getFieldsValue()).then(() => {
                form.resetFields();
                onOffersChanged()
            })
            message.success('Aanbod bijgewerkt!')
            return
        }
        const data = {
            ...form.getFieldsValue(),
            planting_id: plantingId
        }
        api.createOffer(data).then(() => {
            form.resetFields();
            onOffersChanged()
            message.success('Aanbod aangemaakt!')
        })
    }

    useEffect(() => {
        if (offer && offer.id) {
            form.setFieldsValue({
                ...offer,
                start_at: dayjs(offer.start_at),
                end_at: dayjs(offer.end_at)
            })
        }
    }, [offer]);

    useEffect(() => {
        if(offer) {
            return
        }
        form.setFieldsValue(initialValues);
    }, [initialValues]);


    return (
        <Form
            layout="vertical"
            form={form}
            onFinish={onSubmit}
        >
            <Form.Item name="title" label="Title" rules={[{required: true}]}>
                <Input/>
            </Form.Item>

            <Form.Item name="description" label="Omschrijving">
                <Input.TextArea rows={4}/>
            </Form.Item>

            <Row gutter={DEFAULT_GUTTER}>
                <Col span={10}>
                    <Form.Item name="price" label="Prijs" rules={[{required: true}]}>
                        <InputNumber min={0} step={0.01} style={{width: "100%"}}/>
                    </Form.Item>
                </Col>
                <Col span={2}>
                    <div style={{marginTop: "32px"}}>per</div>
                </Col>
                <Col span={10}>
                    <Form.Item name="unit" label="Eenheid">
                        <Input placeholder={"stuk, kg, bos, plant, etc"}/>
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item name="stock" label="Voorraad / hoeveelheid">
                <InputNumber min={0} style={{width: "100%"}}/>
            </Form.Item>

            <Form.Item name="image" label="Afbeelding">
                <Input type={"hidden"}/>
                <CdnImageUpload onUploaded={(url) => {
                    form.setFieldsValue({image: url});
                }} imageUrl={image}/>
            </Form.Item>

            <Row gutter={DEFAULT_GUTTER}>
                <Col span={12}>
                    <Form.Item name="start_at" label="Start verkoop">
                        <DatePicker format={DATE_FORMAT} style={{width: "100%"}}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="end_at" label="Einde verkoop">
                        <DatePicker format={DATE_FORMAT} style={{width: "100%"}}/>
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item className={"text-right"}>
                <Button type="primary" htmlType="submit">
                    {(offer && offer.id) ? "Aanbod bijwerken" : "Aanbod toevoegen"}
                </Button>
            </Form.Item>
        </Form>
    )
}